export const showButtonLoader = (submitButton) => {
    submitButton.append('<span class="register-btn-loader"> <i class="fas fa-circle-notch fa-spin fa-fw"></i></span>');
    submitButton.attr("disabled", true);
}

export const hideButtonLoader = (submitButton) => {
    submitButton.find('.register-btn-loader').remove();
    submitButton.attr("disabled", false);
}

export const isStrongPassword = (passwordValue) => {
  return (/\d/.test(passwordValue) // must contain at least one digit
    && /[A-Z]/.test(passwordValue) // must contain at least one uppercase character
    && /[a-z]/.test(passwordValue) // must contain at least one lowercase character
    && passwordValue.length >= 6 // At least 6 characters long
    && passwordValue.length <= 20); // Maximum 20 characters long
}

export const getStrongPasswordErrorMessage = () => {
  return '6+ and max 20 chars, 1 digit, 1 uppercase & 1 lowercase letter required.';
}



// WEBPACK FOOTER //
// ./scripts/util/helpers.js